import React from 'react';
import { checkApplicationToken, mutateSignIn, approveApplication } from './../../utils/gql';
import { QueryHandler } from './../../utils/common';
import { Mutation } from 'react-apollo';
import SignInForm from './../Login/SignInForm';
import { css } from 'emotion';

const explainationText = css`
  white-space: initial;
`;

const SendConfirm = ({ token, id, agreement }) => {
    const variables = { token, id, agreement };
    return <React.Fragment>
        <QueryHandler
            query={approveApplication}
            variables={variables}
            handler={
                ({ approveApplication: { valid } }) => {
                    if (valid) {
                        return (
                            <div className="text-center">
                                <p><span className="label label-success">&nbsp;Approval is complete.&nbsp;</span></p>
                            </div>
                        )
                    } else {
                        return (
                            <div className="text-center">
                                <p><span className="label label-error">&nbsp;Looks like that application has already been processed.&nbsp;</span></p>
                            </div>
                        );
                    }
                }
            } />

    </React.Fragment>
};

const ConfirmLogin = ({ token }) => (
    <Mutation mutation={mutateSignIn}>{(signIn, { data, loading, error }) => {
        const onSubmit = variables => signIn({ variables });
        const agreement = "I am the guardian for this child, or have obtained consent from their guardian to approve this child to the platform.";
        if (data && data.login) {
            console.log(data);
            return <SendConfirm token={token} id={data.login.id} agreement={agreement} />
        }
        return <React.Fragment>
            <div className="panel-header text-center"><h1>Confirm Application</h1></div>
            <div className={`${explainationText} panel-body`}>
                <div className="text-center"><p className="label label-warning">Keep our communities safe, only <strong>approve</strong> applications you know.</p></div>
                <div className="">
                    <p>By signing in you agree to the following.</p>
                    <blockquote>{agreement}</blockquote>
                    <SignInForm
                        onSubmit={onSubmit}
                        loading={loading}
                        error={error}
                        invalid={data && !data.login}
                        buttonLabel='Login to Approve Application'
                    />
                </div>
            </div>
        </React.Fragment>
    }}</Mutation>
);

const ConfirmForm = ({ token }) => {
    const variables = { token };
    return <React.Fragment>
        <QueryHandler
            query={checkApplicationToken}
            variables={variables}
            handler={
                ({ checkApplicationToken: { valid } }) => {
                    if (valid) {
                        return (
                            <div>
                                <ConfirmLogin token={token} />
                            </div>
                        )
                    } else {
                        return (
                            <div className="text-center">
                                <p><span className="label label-error">&nbsp;That confirm link is invalid.&nbsp;</span></p>
                            </div>
                        );
                    }
                }
            } />

    </React.Fragment>
};

export default class extends React.Component {
    constructor() {
        super();
        this.state = {};
    }

    render() {
        const path = (this.props.location.pathname).split('/') || [];
        const token = path[3] || null;
        return (
            <ConfirmForm token={token} />
        );
    }
};
